'use client';
import { Link } from '@kohler-dsm-library/kohler-core';

/**
 * Custom 404 Not Found page
 * This page is shown when a route is not found or when notFound() is called
 */

const goBackHomeProps = {
  size: 'medium',
  children: 'Go to Home',
  underline: true,
  href: '/en',
};

const goBackProps = {
  size: 'medium',
  children: 'Go Back',
  underline: true,
};

export default function NotFound() {
  return (
    <div
      className="not-found-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '3rem', margin: '0 0 1rem 0', color: '#333' }}>404</h1>
      <h2 style={{ fontSize: '1.5rem', margin: '0 0 1rem 0', color: '#666' }}>Page Not Found</h2>
      <p style={{ fontSize: '1rem', margin: '0 0 2rem 0', color: '#666', maxWidth: '600px' }}>
        Sorry, the page you are looking for doesn&apos;t exist or has been moved. Please check the
        URL or navigate back to the home page.
      </p>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link {...goBackHomeProps} />
        <Link {...goBackProps} onClick={() => window.history.back()} />
      </div>
    </div>
  );
}
